export const LAYOUT_CONSTANTS = {
  APPBAR_HEIGHT_DENSE: 48,
  APPBAR_LOGO_HEIGHT: 32,
  APPBAR_LOGO_MAX_WIDTH: 120,
};
